<template>
  <vs-row v-if="members">
    <vs-col>
      <vs-row>
        <vs-col>
          <div class="vx-card__title mb-6"><h4 class="">{{ $t('dashboard.block.members.title') }}</h4></div>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <vs-table stripe :data="members.$getEmbedded('members') || []" :noDataText="$t('dashboard.block.members.none')">
            <template slot="thead">
            <vs-th>
              {{ $t('dashboard.block.members.columns.name') }}
            </vs-th>
            <vs-th>
              {{ userIdLabel || $t('dashboard.block.members.columns.id') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.members.columns.program') }}
            </vs-th>
            <vs-th v-if="hasPhq9Permission">
              {{ $t('dashboard.block.members.columns.checkup_date') }}
            </vs-th>
            <vs-th v-else>
              {{ $t('dashboard.block.members.columns.referral_date') }}
            </vs-th>
            <vs-th v-if="hasPhq9Permission">
              {{ $t('dashboard.block.members.columns.phq9_self_harm') }}
            </vs-th>
            <vs-th v-else>
              {{ $t('dashboard.block.members.columns.days_referral_accepted') }}
            </vs-th>
            <vs-th>
            </vs-th>
            </template>

            <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].firstname">
                {{ data[indextr].firstName }} {{ data[indextr].lastName }}
              </vs-td>
              <vs-td :data="data[indextr].claimNumber">
                {{ data[indextr].claimNumber }}
              </vs-td>
              <vs-td :data="data[indextr].program">
                <span v-if="data[indextr].$hasEmbedded('access-code')">{{ $t('filters.REFERRAL_PROGRAMS.values.' + data[indextr].$getEmbedded('access-code').program) }}</span>
                <span v-else>{{$t('filters.REFERRAL_PROGRAMS.values.none')}}</span>
              </vs-td>
              <vs-td v-if="hasPhq9Permission" :data="data[indextr].phq9SelfHarmAnswer.checkupDate">
                {{ formatDateTime(data[indextr].phq9SelfHarmAnswer.checkupDate) }}
              </vs-td>
              <vs-td v-else :data="data[indextr].referredDate">
                {{ data[indextr].$getEmbedded('referral').$getEmbedded('referral-acceptance').firstSent | moment('MMMM D, YYYY') }}
              </vs-td>
              <vs-td v-if="hasPhq9Permission" :data="data[indextr].phq9SelfHarmAnswer">
                <div class="content-center">
                  <div class="custom-circle-dot" :style="applyColorCode(data[indextr].phq9SelfHarmAnswer.choiceNumber)"></div>
                  {{ data[indextr].phq9SelfHarmAnswer.choiceText }}
                </div>
              </vs-td>
              <vs-td v-else :data="data[indextr].daysSinceRegistration">
                {{ data[indextr].$getEmbedded('referral').$getEmbedded('referral-acceptance').accepted | moment('from', 'now') }}
              </vs-td>
              <vs-td>
                <vs-button v-if="data[indextr].$hasLink('member')"  @click="onView(data[indextr])" size="small" type="filled" color="secondary">
                  {{ $t('dashboard.block.members.buttons.view') }}
                </vs-button>
              </vs-td>
            </vs-tr>
            </template>
          </vs-table>
        </vs-col>
        <vs-col class="mt-5">
          <vs-row>
            <vs-col vs-w="6" vs-align="left" vs-justify="left" class="text-left">
              <a v-if="displaySeeMore" style="cursor:pointer;" @click="onSeeMore">[+] {{ $t('dashboard.block.members.buttons.view_more') }}</a>
              <a v-if="displaySeeLess" style="cursor:pointer;" @click="onSeeLess">[-] {{ $t('dashboard.block.members.buttons.view_less') }}</a>
            </vs-col>
            <vs-col vs-w="6" vs-align="right" vs-justify="right" class="text-right">
              <router-link :to="{name:'app-view-members'}">{{ $t('dashboard.block.members.buttons.view_all') }}</router-link>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import moment from 'moment';
import DashboardStatistic from '@/views/app/dashboard-statistic';
import {ResourceImpl} from 'hal-client';

export default {
  name: 'dashboard-member-list',
  components: {DashboardStatistic},
  props: {
    dashboardResource: ResourceImpl
  },
  data () {
    return {
      members: null,
      userIdLabel : null,
      hasPhq9Permission: null
    };
  },
  mounted () {
    this.dashboardResource.$request().$get('user-id-label', null, {locale:'en'}).then((res) => {
      this.userIdLabel = res.state().label;
    });
  },
  computed: {
    displaySeeMore () {
      return this.members && this.members.$hasEmbedded('members') && this.members.$hasLink('next') && this.members.page.size < 20;
    },
    displaySeeLess () {
      return this.members && this.members.$hasEmbedded('members') && this.members.page.totalElements > 5 && (this.members.page.size >= 20 || !this.members.$hasLink('next'));
    }
  },
  watch: {
    dashboardResource: {
      immediate: true,
      deep: true,
      handler (newValue) {
        this.doUpdate(newValue);
      }
    }
  },
  methods: {
    doUpdate (newValue) {
      if (newValue.$hasLink('members')) {
        newValue.$request().$get('members').then(res => {
          this.members = res;
          const metadataLink = this.members.$link('metadata-flag').href;
          const url = new URL(metadataLink);
          const params = new URLSearchParams(url.search);
          this.hasPhq9Permission = params.get('hasPhq9Permission') === 'true';
        });
      }
    },
    onSeeMore () {
      this.members.$request().$get('self', {size: this.members.page.size + 5}).then(res => {
        this.members = res;
      });
    },
    onSeeLess () {
      this.members.$request().$get('self', {size: 5}).then(res => {
        this.members = res;
      });
    },
    onView (member) {
      this.$router.push({
        name: 'app-view-member',
        params: {id: member.id}
      });
    },
    formatDateTime (dateTime) {
      if (!dateTime) {
        return;
      }
      if (!moment(dateTime).isValid()) {
        return;
      }
      const now = moment();
      const dateMoment = moment(dateTime);
      const duration = moment.duration(now.diff(dateMoment));
      const hours = duration.asHours();
      const days = duration.asDays();
      const weeks = duration.asWeeks();

      if (hours < 1) {
        return '<1 hour ago';
      }
      if (hours < 24) {
        return `${Math.floor(hours)} hours ago`;
      }
      if (days < 7) {
        return `${Math.floor(days)} days ago`;
      }
      if (weeks <= 8) {
        return `${Math.floor(weeks)} weeks ago`;
      }
      return dateMoment.format('MMMM D, YYYY');
    },
    applyColorCode (value) {
      switch (value) {
      case 0:
        return { backgroundColor: '#5EEC65' };
      case 1:
        return { backgroundColor: '#F7A300' };
      case 2:
        return { backgroundColor: '#DF2800' };
      case 3:
        return { backgroundColor: '#A71F1F' };
      default:
        return { backgroundColor: '#DCDCDC' };
      }
    }
  }
};

</script>

<style scoped>
.content-center {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  flex-grow: 0;
}
.custom-circle-dot {
  height: 1.5em;
  width: 1.5em;
  border-radius: 50%;
  flex-shrink: 0;
  flex-grow: 0;
  aspect-ratio: 1 / 1;
  margin-right: 8px;
}

</style>
